import AdminComingSoonPage from '../../../components/admin/AdminComingSoonPage'

export default function Notifications() {
  return (
    <AdminComingSoonPage
      title="Admin notifications"
      summary="Admin ops inbox is Phase 2. Customer/merchant/rider push is live in their apps."
    />
  )
}
